import { Button } from "../../cta_utils/AnButton"
import Tooltip from "../../cta_utils/Tooltip";
import { useTempMapperContext } from "./contexts/temp_mapper_context";
import { ALL_MAPPER_ACTIONS } from "./reducers/TempMapperReducer";

const MapButton = ({ item }) => {
    const { pageData, pageDataReducer } = useTempMapperContext();
    const mappingItems = [...pageData.mappingItems]
    const handleMap = (item) => {
        pageDataReducer({
            type: ALL_MAPPER_ACTIONS['SET_STATE'], payload: {
                popupsList: { mapConfirmationPopup: true },
                currItem: item
            }
        })
    }
    const handleDiscard = (item) => {
        pageDataReducer({
            type: ALL_MAPPER_ACTIONS['SET_STATE'], payload: {
                popupsList: { discardConfirmationPopup: true },
                currItem: item
            }
        })
    }

    const handleOnChange = (e) => {
        let val = e.target.value
        let index = mappingItems.indexOf(val)
        if (index == -1) {
            pageDataReducer({
                type: ALL_MAPPER_ACTIONS['SET_STATE'], payload: {
                    mappingItems: [...mappingItems, val]
                }
            })
        }
        else {
            let temp = [...mappingItems]
            temp.splice(index, 1)
            pageDataReducer({
                type: ALL_MAPPER_ACTIONS['SET_STATE'], payload: {
                    mappingItems: temp
                }
            })
        }
    }
    return (
        <div className="default_flex_container">
            <div className="default_flex_container" style={{flexDirection: 'column'}}>
            <Button
                buttonSize="Small"
                innerButtonStye={{ padding: "7px 12px" }}
                buttonStyle={{ textAlign: 'center' }}
                onClick={() => handleMap(item)}
            >
                Map
            </Button>
            <Button
                buttonSize="Medium"
                innerButtonStye={{ padding: "7px 12px", background: '#F94545' }}
                buttonStyle={{ textAlign: 'center', marginTop: 12 }}
                onClick={() => handleDiscard(item)}
            >
                Discard
            </Button>
            </div>

            <Tooltip
                tooltipText={() => "Mapper conflict"}
                innerClass='text_body_light'
                textTheme='background-light-black top'
                innerStyle={{ padding: '8px', alignSelf: 'center', color: 'white', borderRadius: '8px' }}
                style={{ textAlign: 'center', zIndex: '9999', paddingRight: 94 }}
                showWithoutOverflowing={true}
                enableTooltip={item.mapper_conflict !== 'no_conflict'}
                tooltipPos="top"
            >
                <div>
                    <input
                        type="checkbox"
                        id={item.id}
                        value={item.id}
                        disabled={item.mapper_conflict !== 'no_conflict'}
                        checked={mappingItems.includes(item.id)}
                        onChange={handleOnChange}
                        style={{ marginLeft: 4, cursor: 'pointer' }}>
                    </input>
                </div>
            </Tooltip>

        </div>
    )
}
export default MapButton